import React from "react";
import { Menu } from "semantic-ui-react";
import UserPanel from "./UserPanel";
import NavigationPanel from "./NavigationPanel";
// import DirectMessages from "../MetaPanel/DirectMessages";
// import Starred from "../MetaPanel/Starred";

class SidePanel extends React.Component {
  render() {
    const { currentUser, primaryColor } = this.props;

    return (
      <Menu
        size="medium"        
        fixed="top"
        horizontal
        
        style={{alignItems: "center", background: primaryColor,height:30 }}
      >
        <NavigationPanel currentUser={currentUser} />
        <UserPanel className="userpanel" primaryColor={primaryColor} currentUser={currentUser} />
        
      </Menu>
    );
  }
}

export default SidePanel;



// WEBPACK FOOTER //
// ./src/components/SidePanel/SidePanel.js